import styled, { css } from "styled-components";
import { COLORS, TEXT_COLORS } from "../constants/design/colors";
import { FONT_CSS, FONT_SIZE } from "../constants/design/fontSize";
import { SPACING, WIDTHS } from "../constants/design/spacing";
import { ConnectWalletButton } from "../components/Buttons/styles";

export const SettingsInputContainer = styled.div``;

export const ToggleContainer = styled.div`
  display: flex;
`;

export const SettingRow = styled.div`
  margin-bottom: ${SPACING.five}px;
`;

export const SettingTitle = styled.div`
  ${FONT_CSS.header.seven}
  color: ${TEXT_COLORS.one};
  margin-bottom: ${SPACING.three}px;
`;

export const SettingDescription = styled.div`
  ${FONT_CSS.body.four}
  color: ${TEXT_COLORS.two};
  margin-bottom: ${SPACING.three}px;

  > strong {
    color: ${TEXT_COLORS.one};
  }
`;

export const SettingsContainer = styled.div<{ isMobile?: boolean }>`
  padding: ${({ isMobile }) =>
      isMobile ? `${SPACING.three}px 0` : `0 ${SPACING.three}px`}
    0 0;
  display: flex;
  flex-direction: column;

  ${SettingsInputContainer} {
    ${({ isMobile }) => {
      if (isMobile) {
        return css`
          display: flex;
          flex-direction: column-reverse;
          > *:first-child {
            margin-top: ${SPACING.three}px;
          }
        `;
      }
      return css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: ${SPACING.five}px;
      `;
    }}
  }

  ${ToggleContainer} {
    ${({ isMobile }) => {
      if (isMobile) {
        return css`
          flex-direction: column-reverse;
          > *:first-child {
            margin-top: ${SPACING.three}px;
          }
        `;
      }
      return css`
        flex-direction: row;
        align-items: center;
        > *:first-child {
          margin-right: ${SPACING.two}px;
        }
      `;
    }}
  }
`;

export const ErrorMessage = styled.span<{
  isSmall?: boolean;
  isMobile?: boolean;
}>`
  ${({ isSmall }) => (isSmall ? FONT_CSS.label.three : FONT_CSS.body.three)}
  color: ${COLORS.negative.one};
  display: flex;
  ${({ isMobile }) => isMobile && `margin-top: ${SPACING.one}px;`}
`;

export const Contents = styled.div<{ isMobile?: boolean }>`
  color: ${TEXT_COLORS.two};
  font-size: ${FONT_SIZE.two};
  display: flex;
  padding: ${({ isMobile }) => (isMobile ? 0 : SPACING.five)}px;

  ${({ isMobile }) =>
    isMobile
      ? css`
          flex-direction: column;
          padding-top: ${SPACING.three}px;
          ${ConnectWalletButton} {
            width: 100% !important;
          }
        `
      : css`
          @media (max-width: ${WIDTHS.S}px) {
            flex-direction: column;
            ${ConnectWalletButton} {
              width: 100% !important;
            }
          }
        `}

  a {
    color: ${TEXT_COLORS.two};
  }

  > span {
    flex: 1;
  }

  > div {
    flex: 1;
  }
`;
